import { ConnectedSourceProps } from "../../../pages/cdp/types";

export const ConnectedSource: React.FC<ConnectedSourceProps> = ({
  name,
  type,
  status,
}) => (
  <div className="bg-white rounded-lg border border-gray-200 p-4 flex items-center justify-between hover:shadow-md transition-shadow">
    <div className="flex items-center space-x-3">
      <div
        className={`w-2 h-2 rounded-full ${
          status === "Active" ? "bg-green-500" : "bg-yellow-500"
        }`}
      ></div>
      <div>
        <div className="font-medium text-gray-900">{name}</div>
      </div>
    </div>
    <div className="flex items-center space-x-3">
      <span className="text-sm text-gray-600">{type}</span>
      <button className="text-blue-600 text-sm font-medium hover:text-blue-700 transition-colors">
        Configure
      </button>
    </div>
  </div>
);

export const AiJourneyBuilder: React.FC = () => (
  <div className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow">
    <h3 className="text-lg font-semibold text-gray-900 mb-4">
      Ask AI to build a journey
    </h3>

    <div className="bg-gray-50 rounded-lg p-4 mb-4">
      <input
        type="text"
        placeholder="e.g. Re-engage users who abandoned checkout"
        className="w-full bg-transparent text-gray-700 placeholder-gray-500 border-none outline-none"
      />
    </div>

    <p className="text-xs text-gray-500 leading-relaxed">
      Tip: Mention goals, channels, audience or data sources. We'll turn this
      into a journey with audiences, messages and KPIs.
    </p>
  </div>
);

export const RecentlyCreated: React.FC = () => (
  <div className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow">
    <h3 className="text-lg font-semibold text-gray-900 mb-4">
      Recently Created
    </h3>
    <p className="text-sm text-gray-600">
      Audience • <span className="text-gray-900">High LTV Purchasers</span>
    </p>
    <p className="text-sm text-gray-600">
      Journey • <span className="text-gray-900">Abandoned Cart Recovery</span>
    </p>
  </div>
);